/**
 * created by lei lei on 2020/5/29
 */
import React, {Component} from 'react';
import ResourceStaticComponents from "./components/resourceStatic/ResourceStaticComponents";
import PublishRankingsComponents from "./components/publishRank/PublishRankingsComponents";
import {ActivityPendingComponentsOtherGwxw} from "./components/activityPending/ActivityPendingComponentsOtherGwxw";
import MyMessage from "./components/myMessage/MyMessage"
import './StatciMyDesktop.css'
import NewsTaskComponents from "./components/activityPending/NewsTaskComponents";
import {Scrollbars} from 'react-custom-scrollbars';
import MediaAppointNeedTodoComponent from "./components/activityTrends/MediaAppointNeedTodoComponent";

export default class StaticMyDeskGw extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let height = window.innerHeight - 70
        return (
            <div style={{position: 'relative', height: height,}}>
                <Scrollbars>
                    <div className={'myDeskPadding'} style={{position: 'relative', marginBottom: 20}}>

                        {/*  <Head/>*/}
                        <div style={{display: 'flex'}}>
                            <div className={'myDeskLeft'} style={{width: '55%',}}>
                                <MediaAppointNeedTodoComponent/>
                                <NewsTaskComponents/>
                                <ActivityPendingComponentsOtherGwxw/>
                                {/*<FollowUpCorrespondenceComponents/>*/}
                                {/*<ActivityCompletionComponents/>*/}
                                {/*<ActivityRankingComponents/>*/}
                                {/*<TopicSubmissionReminderComponents/>*/}
                                <PublishRankingsComponents/>
                            </div>
                            <div className={'myDeskRight'} style={{width: '45%',}}>
                                {/*<ActivityTrendsComponents/>*/}
                                <MyMessage/>
                                <ResourceStaticComponents/>
                            </div>
                        </div>

                    </div>
                </Scrollbars>
            </div>
        )
    }
}

